import { PortalAwareSelect } from '@/components/select/PortalAwareSelect';
import type { AccessUser } from '@/entities/user/types';

/** One `{ id, name }` entry of a name-sorted available-markets list (login and `me` payloads). */
export type MarketOption = AccessUser['availableMarkets'][number];

interface Props {
  markets: MarketOption[];
  value: string;
  onValueChange: (marketId: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  'aria-label': string;
}

/** Market select shared by the post-login MarketSelectDialog and the topbar MarketSwitcher. */
export const MarketSelect = ({ markets, placeholder = 'Select market', ...props }: Props) => (
  <PortalAwareSelect
    {...props}
    options={markets.map((market) => ({ value: market.id, label: market.name }))}
    placeholder={placeholder}
  />
);
